import BaseApiService from "./baseApiService.mjs";


class ClaimService extends BaseApiService {

  // Get claim details by ID and type
  async getClaimDetails(claimId, claimType) {
    try {
      // Use the correct endpoint paths that match the backend routes
      const endpoint = claimType === 'PerDiemClaim'
        ? `/perdiem/claims/${claimId}`
        : `/expenses/claims/${claimId}`;
      const response = await this.api.get(endpoint);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch claim details');
    }
  }

  // Get approved claims for a specific month/year/region
  async getApprovedClaims(month, year, region) {
    try {
      const response = await this.api.get('/claims/approved', {
        params: { month, year, region }
      });
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch approved claims');
    }
  }
}

const claimService = new ClaimService();
export default claimService;

